
import React from "react";
// import { FaArrowRight } from "react-icons/fa6";
// import { SlSocialFacebook } from "react-icons/sl";
// import { FaInstagram } from "react-icons/fa";
// import { SlSocialLinkedin } from "react-icons/sl";
// import { FaXTwitter } from "react-icons/fa6";



import styles from "./Icon.module.css";

// const Icon = ({Icon, link}) => {
//   return (
//     <div className={styles.circle}>
//       <Icon onClick={link} className={styles.icon} />
//     </div>
//   );
// };

// export default Icon;

const Icon = ({ Icon, link }) => {
  return (
    <div
      className={styles.circle}
      onClick={() => window.open(link, "_blank")}
    >
      <Icon className={styles.icon} />
    </div>
  );
};

export default Icon;